// extracted by mini-css-extract-plugin
module.exports = {"container":"parallax_layer-module--container--1X340"};